import { DialogActions, DialogContent, Button, CircularProgress, Grid } from '@mui/material';
import { Field, useFormikContext } from 'formik';
import React from 'react';
import { toast } from 'react-toastify';
import { SelectFormField } from 'v2/components/Shared/FormFields/SelectFormField';
import { TextFormField } from 'v2/components/Shared/FormFields/TextFormField';
import webhookService from 'v2/services/webhook';

import { useWebhookContext } from '../context';
import { WebhookTypes } from '../interfaces';
import UrlValidationFormField from './UrlValidationFormField';

import type { ProductWebhook, FieldsWebHook } from '../interfaces';

const Fields = React.memo(() => {
  const { setSelectedWebhook, setIsFormOpen } = useWebhookContext();
  const { isSubmitting, isValid, values } = useFormikContext<FieldsWebHook>();
  const [isUrlValidated, setIsUrlValidated] = React.useState(false);
  const [loading, setLoading] = React.useState<boolean>(true);
  const [products, setProducts] = React.useState<ProductWebhook[]>([]);

  const getProducts = React.useCallback(() => {
    webhookService
      .getProducts()
      .pipe()
      .subscribe((res) => {
        setProducts(res.data.map((p: ProductWebhook) => ({ label: p.title, value: p.productId, id: p.productId })));
        setLoading(false);
      }, toast.error);
  }, []);

  const onClose = () => {
    setSelectedWebhook(null);
    setIsFormOpen(false);
  };

  React.useEffect(() => {
    getProducts();
  }, [getProducts]);

  const editing = !!values?._id;

  return (
    <>
      <DialogContent dividers>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Field id='type' name='type' label='Tipo' disabled={editing} fullWidth options={WebhookTypes} component={SelectFormField} />
          </Grid>
          <Grid item xs={12}>
            <Field id='description' name='description' label='Nome' fullWidth component={TextFormField} />
          </Grid>

          <Grid item xs={12}>
            <Field
              id='product_id'
              name='product_id'
              disabled={editing || loading}
              label='Produto'
              loading={loading}
              fullWidth
              options={products}
              component={SelectFormField}
            />
          </Grid>

          <Grid item xs={12}>
            <Field
              id='url'
              name='url'
              label='URL'
              fullWidth
              component={UrlValidationFormField}
              helperText='Insira uma URL válida, obrigátorio http:// ou https://'
              onValidateUrl={setIsUrlValidated}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button disabled={isSubmitting} onClick={onClose}>
          Cancelar
        </Button>

        <Button
          disabled={isSubmitting || !isValid || !isUrlValidated}
          type='submit'
          variant='contained'
          color='primary'
          startIcon={isSubmitting && <CircularProgress size={16} />}
        >
          Salvar
        </Button>
      </DialogActions>
    </>
  );
});

export default Fields;
